import React from "react";
import "./styles.css";

export default function Footer() {
  return (
    <div>
      <small>        
          Open-source code, by Yuliia Korotchenko  {""}       
          <a
          href="https://github.com/YuliiaKorotchenko/weather-app-react"
            target="_blank"
            rel="noopener noreferrer">          
            open-sourced on GitHub</a>  {""}        
          and is {""}
          <a
            href="https://bejewelled-kitten-797cee.netlify.app/"
            target="_blank"
            rel="noopener noreferrer"
          >{""}hosted on Netlify</a>
      </small>
    </div>
  );
}
